import React from "react";
import IntroSection from "../components/IntroSection";
import NumberedHeading from "../components/NumberedHeading";
import ListView from "../components/ListView";
import { useRecoilState } from "recoil";
import { detailedResultState } from "../../../utils/recoil";
import { useTranslation } from "react-i18next";

const LearningStyle = () => {
  const [data] = useRecoilState(detailedResultState);

  const { t } = useTranslation("result");

  return (
    <div className="flex flex-col gap-10">
      <IntroSection text={data?.learning_style?.introduction} />
      <NumberedHeading
        number={"1"}
        title={t("learningStyle.title")}
        className={"px-[20rem] md-max:px-[1rem]"}
      />
      <ListView
        example={true}
        className={"px-[20rem]"}
        data={
         data?.learning_style?.data
        }
      />
    </div>
  );
};

export default LearningStyle;
